module.exports = __webpack_public_path__ + "img/stickers-attestation-pension.f897a495.jpg";